import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { swalMessages } from 'src/constants';
import Grid from '@material-ui/core/Grid';
import PresentToAllIcon from '@material-ui/icons/PresentToAll';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import Card from 'src/components/sharedComponents/Card/Card';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import CardIcon from 'src/components/sharedComponents/Card/CardIcon';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import CustomInput from 'src/components/sharedComponents/CustomInput/CustomInput';
import MaterialTable from 'material-table'
import { makeStyles } from '@material-ui/core/styles';
import { MenuItem } from '@material-ui/core';
import reportRequestPermissionsService from 'src/services/reportRequestPermissionsService';
import reportsService from 'src/services/reportsService';
import convertDate from 'src/utils/formatDate';
import styles, { SelectInput } from '../../pages/AdminControl/styles';

const initialState = {
  descripcion: ' ',
};

const ReportRequestPermissions = () => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const [listRequest, setListRequest] = useState([]);
  const [permissions, setpermissions] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [create, setCreate] = useState(initialState);

  const newDate = new Date();

  // obtener reportes para el select
  const getReportDataStudio = async () => {
    const response = await reportsService.getReportDataStudioLuciaByAssigned();
    if (response) {
      setListRequest(response);
    } else {
      swal(swalMessages.WARNING_DATASTUDIO);
    }
  };

  // obtener listado de solicitudes
  const getRequestPermission = async () => {
    const response = await reportRequestPermissionsService.getListPermission();
    if (response) {
      setpermissions(response.data);
    } else {
      swal(swalMessages.WARNING_DATASTUDIO);
    }
  };

  // Enviar solicitud de permisos
  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisabled(true);
    const response = await reportRequestPermissionsService.postPermissionReport(
      create,
    );
    if (response.status) {
      setCreate(initialState);
      swal(swalMessages.SUCCESSFUL_MESSAGE);
      getRequestPermission();
    } else {
      swal({
        title: 'Upsss!!!!',
        text: response.data.error,
        icon: 'warning',
        button: 'Cerrar!',
        dangerMode: true,
      });
    }
    setDisabled(false);
  };

  const onChangeInput = (event, type) => {
    setCreate({
      ...create,
      [type]: event.target.value,
    });
  };

  useEffect(() => {
    getReportDataStudio();
    getRequestPermission();
  }, []);

  return (
    <>
      <CardTitle title="Solicitud de permisos para Reportes " />
      <Grid container justifyContent="center" spacing={2}>
        <Grid item xs={12} md={12} sm={12}>
          <Card>
            <CardHeader color="customAuteco" stats icon>
              <CardIcon color="customAuteco">
                <PresentToAllIcon />
              </CardIcon>
            </CardHeader>
            <CardBody>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <SelectInput
                      className={classes.selectInput}
                      fullWidth
                      required
                      label="Reporte"
                      variant="standard"
                      value={create.reporteId || ''}
                      select
                      onChange={(event) => onChangeInput(event, 'reporteId')}
                    >
                      {listRequest?.map((r, key) => (
                        <MenuItem value={r.id} key={r.id}>{r.nombre}</MenuItem>
                      ))}
                    </SelectInput>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomInput
                      labelText="Correo"
                      id="correo"
                      formControlProps={{
                        fullWidth: true,
                        required: true,
                      }}
                      inputProps={{
                        value: create.correo || '',
                        onChange: (event) => onChangeInput(event, 'correo'),
                        type: 'email',
                        autoComplete: 'off',
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <SelectInput
                      className={classes.selectInput}
                      fullWidth
                      required
                      label="Tipo de permiso"
                      value={create.compartir || ''}
                      variant="standard"
                      select
                      onChange={(event) => onChangeInput(event, 'compartir')}
                    >
                      <MenuItem value="Ver">Ver</MenuItem>
                      <MenuItem value="Editar">Editar</MenuItem>
                    </SelectInput>
                  </Grid>
                  <Grid item xs={12} sm={6} />
                  <Button
                    type="onSubmit "
                    color="warning"
                    disabled={disabled}
                    className="justify-content-center"
                  >
                    Crear
                  </Button>
                </Grid>
              </form>
            </CardBody>
          </Card>
        </Grid>
        <Grid item xs={12} md={12} sm={12}>
          <MaterialTable
            title="Solicitudes de Permiso"
            columns={[
              { title: 'Fecha', field: 'Fecha' },
              { title: 'Reporte', field: 'Reporte' },
              { title: 'Correo', field: 'Correo' },
              { title: 'Estado', field: 'Estado' },
            ]}
            data={permissions?.map((item) => ({
              Fecha: convertDate(newDate),
              Reporte: item.reporte.nombre,
              Correo: item.correo,
              Estado: item.estado,
            }))}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ReportRequestPermissions;
